var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"morris-chart mt-4",attrs:{"id":_vm.chart_id + '_bar'}})])}
var staticRenderFns = []

export { render, staticRenderFns }